import { countryCodeSchema } from '@noconflict/contracts';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useOrgScope } from '../../entities/org';
import { CreateOrgDialog } from '../../features/org/create-org';
import { OrgSwitcherMenu } from '../../features/org/switch-org';
import type { ShellSlotContext } from './nav-config';

/** Fills the shell's switcher slot: current org, memberships, "Create organization". */
export function OrgSwitcher({ collapsed, inDrawer, onNavigate }: ShellSlotContext) {
  const scope = useOrgScope();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const ready = scope.status === 'ready';
  // A further org usually sits in the same country as the current one; the person can change it.
  const country = countryCodeSchema.safeParse(ready ? scope.shellOrg?.country : undefined);
  return (
    <>
      <OrgSwitcherMenu
        organizations={ready ? scope.organizations : []}
        current={ready ? scope.shellOrg : null}
        workspaceCount={ready ? scope.activeWorkspaces.length : 0}
        collapsed={collapsed}
        inDrawer={inDrawer}
        onCreate={() => setCreating(true)}
        {...(onNavigate ? { onNavigate } : {})}
      />
      <CreateOrgDialog
        open={creating}
        onOpenChange={setCreating}
        onCreated={(org) => {
          onNavigate?.();
          navigate(`/o/${org.slug}`);
        }}
        {...(country.success ? { defaultCountry: country.data } : {})}
      />
    </>
  );
}
